<template>
  <el-table class="dt-table" :max-height="height" :data="data" border :highlight-current-row="true" stripe v-hover>
    <!-- 序号插槽 -->
    <slot name="index"></slot>
    <!-- 单选按钮插槽 -->
    <slot name="radio"></slot>

    <el-table-column
      v-for="item in newOptions"
      :key="item.prop"
      :prop="item.prop"
      :label="item.label"
      :align="align"
      :min-width="item.width"
      :width="item.basewidth"
      :show-overflow-tooltip="item.showoverflowtooltip"
    >
      <template slot-scope="scope">
        <!-- 当数据有绑定事件时 -->
        <template v-if="item.event">
          <template v-if="item.event === 'getImage'">
            <div class="tableImgWrap">
              <img class="tableImg" v-if="scope.row.imageUrl" :src="scope.row.imageUrl" alt />
              <span class="tableImgLine" v-else>--</span>
            </div>
          </template>
          <template v-else>
            <span class="cursor" @click="handleClick(item.event, scope.row)" :style="{ color: themeObj.color }"
              >{{ scope.row[item.prop] }}{{ item.unit ? item.unit : '' }}</span
            >
          </template>
        </template>
        <!-- 只是普通数据，需要查询字典转换或特定方法过滤 -->
        <template v-else>
          <template v-if="item.dic">
            <!-- 适配某个字段字典要分开加载情况 -->
            <span v-if="item.mutildic">
              {{
                scope.row[item.prop.split(',')[scope.row.preservationSource * 1]]
                  | getDicItemName(item.mutildic[scope.row.preservationSource * 1])
              }}
            </span>
            <span v-else>{{ scope.row[item.prop] | getDicItemName(item.dic) }}{{ item.unit ? item.unit : '' }}</span>
          </template>
          <template v-else
            >
             <span class="WelfareFlag" v-if="item.WelfareFlag&&scope.row.isWelfare==1">弹性福利</span>
            {{ getCeil(item.filterType, scope.row[item.prop]) }}{{ item.unit ? item.unit : '' }}</template
          >
        </template>
      </template>
    </el-table-column>
    <!-- 操作按钮插槽 -->
    <slot name="operate"></slot>
  </el-table>
</template>

<script>
import { getDicList } from '@/config/tool';

export default {
  props: {
    data: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
    options: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
    align: {
      type: String,
      default: 'left',
    },
    height: { type: String, default: 'auto' },
  },
  //表头的合同编号
  showPolicyCode: {},
  data() {
    return {
      // newOptions: [],
    };
  },
  created() {},
  methods: {
    // 自定义过滤内容方法
    filterType(type, value) {
      return this[type](value);
    },
    filterrecordType(value) {
      switch (value) {
        case 0:
          return "积分失效";
        case 1:
          return "积分分配";
        case 2:
          return "积分消费";
        case 3:
          return "取消订单";
        case 4:
          return "订单退款";
        case 5:
          return "分配扣减";
      }
      // return value == 0 ? '积分失效' : value == 1 ? '积分下发' : value == 2 ? '消费' : '积分冲正';
    },
    // 保留两位小数并添加%
    fixedTwo(value) {
      return Number(value).toFixed(2);
    },
    // 自定义事件，子组件触发，父组件执行
    handleClick(event, row) {
      this.$emit(event, row);
    },
  },
  computed: {
    newOptions() {
      return this.options.map((item) => {
        if (!item.width) {
          if (item.prop === 'name') {
            item.width = Math.max(80, (item.label.length + 1) * 20);
          } else if (/time$/i.test(item.prop)) {
            item.width = 160;
          } else {
            item.width = (item.label.length + 1) * 20;
          }
        }
        return item;
      });
    },
    getCeil() {
      return function (type, prop) {
        if (type) {
          return this.filterType(type, prop);
        } else {
          // 为了正常显示数字0
          if (prop === undefined || prop === '') return '--';
          return prop;
        }
      };
    },
    themeObj() {
      return this.$store.getters['layoutStore/getThemeObj'];
    },
  },
};
</script>
<style lang="less">
.dt-table {
  .tableImgWrap {
    width: 100%;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    .tableImg {
      max-width: 100%;
      max-height: 100%;
    }
    .tableImgLine {
      display: block;
      line-height: 80px;
    }
  }
  .cursor {
    cursor: pointer;
  }
}
.el-table .cell .WelfareFlag {
  position: absolute;
  left: 0;
  top: 0;
  display: inline-block;
  width: 66px;
  height: 18px;
  line-height: 18px;
  border-radius: 0px 0px 14px 0px;
  font-size: 12px;
  font-family: PingFang-SC-Bold, PingFang-SC;
  font-weight: bold;
  color: #ffffff;
  background: linear-gradient(270deg, #E27C00 0%, #F3B300 100%);
}
</style>
